import { apiCall } from './base'
import { API_SUBSCRIPTIONS_URL } from '../config'

export const createSubscriber = (data) =>
  apiCall(`api/v1/subscribers`, {
    baseURL: API_SUBSCRIPTIONS_URL,
    method: 'POST',
    withCredentials: false,
    immediately: true,
    data: {
      ...data,
      origin: 'WALLET',
      product: 'memberships',
      notifications: [],
      categories: [],
      termsAccepted: true
    }
  })
